module.exports = __webpack_public_path__ + "img/mp3.71be0b3b.png";